// @flow
import { push } from 'react-router-redux';
import { fetchMe } from './user.actions';

const ACCOUNTS_URL = '/api/projects/:id/accounts';
const WEB_PROPERTIES_URL = '/api/projects/:id/accounts/:accountId/webProperties';
const DIMENSIONS_URL =
  '/api/projects/:id/accounts/:accountId/webProperties/:webPropertyId/dimensions';
const UA_VARS_URL = '/api/projects/:id/gtm/accounts/:accountId/containers/:containerId/uaVariables';

const SETUP_URL = '/api/projects/:id/gtm/accounts/:accountId/containers/:containerId';

const PROJECTS_URL = `/api/projects`;
const PROJECT_URL = `/api/projects/:id`;
const PROJECT_ANALYTICS_SUMMARY_URL = `/api/projects/:id/summary`;
const PROJECT_GTM_URL = `/api/projects/:id/gtm`;
const PROJECT_GA_URL = `/api/projects/:id/ga`;
const PROJECT_AVAILABLE_URL = `/api/projects/:id/enabled`;
const SOURCE_CODE_TAG_URL = '/api/projects/:id/source-tag';

export const PROJECT_SETTING_UP = 'setup/PROGRESS';
export const PROJECT_SETTING_UP_DONE = 'setup/DONE';

export const SUMMARY_UPDATED = 'summary/UPDATED';
export const SUMMARY_UPDATING = 'summary/UPDATING';
export const SUMMARY_EMPTY_ERROR = 'summary/EMPTY';
export const SUMMARY_FETCH_ERROR = 'summary/ERROR';

export const DIMENSIONS_UPDATED = 'dimensions/UPDATED';
export const DIMENSIONS_UPDATING = 'dimensions/UPDATING';
export const DIMENSIONS_FETCH_ERROR = 'dimensions/ERROR';

export const ACCOUNTS_UPDATED = 'accounts/UPDATED';
export const ACCOUNTS_UPDATING = 'accounts/UPDATING';
export const ACCOUNTS_FETCH_ERROR = 'accounts/ERROR';
export const ACCOUNTS_EMPTY_ERROR = 'accounts/EMPTY_ERROR';
export const ACCOUNTS_REMOVE = 'accounts/REMOVE';

export const OPEN_REMOVE_PROJECT_DIALOG = 'accounts/SHOW_REMOVE_DIALOG';
export const CLOSE_REMOVE_PROJECT_DIALOG = 'accounts/CLOSE_REMOVE_DIALOG';
export const OPEN_DISABLE_PROJECT_DIALOG = 'accounts/SHOW_DISABLE_DIALOG';
export const CLOSE_DISABLE_PROJECT_DIALOG = 'accounts/CLOSE_DISABLE_DIALOG';

export const OPEN_WORKSPACE_DONE_DIALOG = 'projects/OPEN_WORKSPACE_DONE_DIALOG';
export const CLOSE_WORKSPACE_DONE_DIALOG = 'projects/CLOSE_WORKSPACE_DONE_DIALOG';
export const OPEN_VERSION_DONE_DIALOG = 'projects/OPEN_VERSION_DONE_DIALOG';
export const CLOSE_VERSION_DONE_DIALOG = 'projects/CLOSE_VERSION_DONE_DIALOG';

export const PROPERTIES_UPDATED = 'properties/UPDATED';
export const PROPERTIES_CREATED = 'properties/CREATED';
export const PROPERTIES_UPDATING = 'properties/UPDATING';
export const PROPERTIES_CREATING = 'properties/CREATING';
export const WORKSPACE_CREATING = 'workspace/CREATING';
export const WORKSPACE_CREATED = 'workspace/CREATED';
export const PROPERTIES_FETCH_ERROR = 'properties/ERROR';
export const GA_SAVING = 'ga/SAVING';
export const GA_SAVED = 'ga/SAVED';
export const GTM_SAVING = 'gtm/SAVING';
export const GTM_SAVED = 'gtm/SAVED';

export const SOURCE_CODE_RECEIVE_START = 'project/SOURCE_CODE_RECEIVE_START';
export const SOURCE_CODE_RECEIVED = 'project/SOURCE_CODE_RECEIVED';

export const getTagSourceCode = ({
  id,
  datapoints,
  cb
}: {
  cb: Function,
  datapoints: Array<Object>,
  id: string
}) => {
  return (dispatch: Function) => {
    dispatch({ type: SOURCE_CODE_RECEIVE_START });
    fetch(SOURCE_CODE_TAG_URL.replace(':id', `${id}`), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include',
      body: JSON.stringify({
        datapoints
      })
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data: { tag }, status }) => {
        dispatch({
          type: SOURCE_CODE_RECEIVED,
          data: {
            tag,
            id
          }
        });

        if (cb) cb.call(this, { tag });
      });
  };
};

export const getAccounts = ({ cb, id }: { cb: Function, id: string }) => {
  const fetchUrl = ACCOUNTS_URL.replace(':id', `${id}`);
  return (dispatch: Function) => {
    dispatch({ type: ACCOUNTS_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 403) {
          if (data && data.internal && data.internal === '403-1') {
            return dispatch({ type: ACCOUNTS_EMPTY_ERROR, data });
          }

          return dispatch({ type: ACCOUNTS_FETCH_ERROR, data });
        }
        dispatch({
          type: ACCOUNTS_UPDATED,
          data
        });
        if (cb) cb.call(this, data);
      });
  };
};
export const getSummary = ({ id }: { id: string }) => {
  const fetchUrl = PROJECT_ANALYTICS_SUMMARY_URL.replace(':id', `${id}`);
  return (dispatch: Function) => {
    dispatch({ type: SUMMARY_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 403) {
          if (data && data.internal && data.internal === '403-1') {
            return dispatch({ type: SUMMARY_EMPTY_ERROR, data });
          }

          return dispatch({ type: SUMMARY_FETCH_ERROR, data });
        }
        dispatch({
          type: SUMMARY_UPDATED,
          data
        });
      });
  };
};

export const getWebProperties = ({
  cb,
  id,
  accountId
}: {
  cb: Function,
  id: string,
  accountId: string
}) => {
  const fetchUrl = WEB_PROPERTIES_URL.replace(':id', `${id}`).replace(':accountId', `${accountId}`);
  return (dispatch: Function) => {
    dispatch({ type: PROPERTIES_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 403) {
          return dispatch({ type: PROPERTIES_FETCH_ERROR, data });
        }
        dispatch({
          type: PROPERTIES_UPDATED,
          data
        });
      })
      .catch((err) => {
        dispatch({ type: PROPERTIES_FETCH_ERROR, err });
      });
  };
};
export const getDimensions = ({
  id,
  accountId,
  webPropertyId
}: {
  id: string,
  accountId: string,
  webPropertyId: string
}) => {
  const fetchUrl = DIMENSIONS_URL.replace(':id', `${id}`)
    .replace(':accountId', `${accountId}`)
    .replace(':webPropertyId', `${webPropertyId}`);
  return (dispatch: Function) => {
    dispatch({ type: DIMENSIONS_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 403) {
          return dispatch({ type: DIMENSIONS_FETCH_ERROR, data });
        }
        dispatch({
          type: DIMENSIONS_UPDATED,
          data
        });
      })
      .catch((err) => {
        dispatch({ type: DIMENSIONS_FETCH_ERROR, err });
      });
  };
};

export const saveGtmSettings = ({
  idx,
  id,
  accountId,
  containerId,
  workspaceId,
  containerName,
  publicId
}: {
  idx: string,
  id: string,
  accountId: string,
  containerId: string,
  containerName: string,
  publicId: string,
  workspaceId: string
}) => {
  return (dispatch: Function) => {
    let fetchUrl = PROJECT_GTM_URL.replace(':id', `${id}`);

    dispatch({ type: GTM_SAVING });
    fetch(fetchUrl, {
      method: 'POST',
      body: JSON.stringify({ accountId, containerId, workspaceId, containerName, publicId }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch(
          fetchMe((userData) => {
            dispatch({
              type: GTM_SAVED
            });
            dispatch(push(`select-web-property?idx=${idx}`));
          })
        );
      });
  };
};
export const setUpProject = ({
  idx,
  id,
  accountId,
  containerId,
  workspaceId,
  accountDatapoints,
  publishTag = true,
  buildTag = true,
  cb
}: {
  idx: string,
  id: string,
  accountId: string,
  containerId: string,
  workspaceId: string,
  accountDatapoints: any,
  publishTag: boolean,
  buildTag: boolean,
  cb: Function
}) => {
  return (dispatch: Function) => {
    let fetchUrl = SETUP_URL.replace(':id', `${id}`)
      .replace(':accountId', `${accountId}`)
      .replace(':containerId', `${containerId}`)
      .replace(':workspaceId', `${workspaceId}`);

    const payload = accountDatapoints.map(({ name, active, scope, sid, description }) => ({
      name,
      active,
      scope: scope || 'HIT',
      sid,
      description
    }));
    dispatch({ type: PROJECT_SETTING_UP });
    fetch(fetchUrl, {
      method: 'PUT',
      body: JSON.stringify({ accountDatapoints: payload, publishTag, buildTag }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (!data.success && data.error && data.error.isLimit) {
          window.location.href = `/auth/with-google/balance?accountId=${
            data.error.accountId
          }&containerId=${data.error.containerId}&projectId=${id}&projectIndex=${idx}`;

          return;
        }
        if (data.versionDone) {
          return dispatch(
            fetchMe(
              (userData) =>
                dispatch({
                  type: OPEN_VERSION_DONE_DIALOG,
                  data: data.versionDone
                }) &&
                dispatch({
                  type: PROJECT_SETTING_UP_DONE
                }) &&
                cb &&
                cb()
            )
          );
        }
        if (data.workspaceDone) {
          return dispatch(
            fetchMe(
              (userData) =>
                dispatch({
                  type: OPEN_WORKSPACE_DONE_DIALOG,
                  data: { ...data.workspaceDone, isError: publishTag }
                }) &&
                dispatch({
                  type: PROJECT_SETTING_UP_DONE
                }) &&
                cb &&
                cb()
            )
          );
        }

        dispatch(
          fetchMe((userData) => {
            dispatch({
              type: PROJECT_SETTING_UP_DONE
            });

            if (cb) cb();
            // dispatch(push(`/wizard/seo-perfomance?idx=${idx}`));
          })
        );
      });
  };
};

export const openDisableProjectDialog = ({ id }: { id: string }) => (dispatch: Function) =>
  dispatch({
    type: OPEN_DISABLE_PROJECT_DIALOG,
    data: id
  });

export const closeDisableProjectDialog = () => (dispatch: Function) =>
  dispatch({
    type: CLOSE_DISABLE_PROJECT_DIALOG
  });

export const openRemoveProjectDialog = ({ id }: { id: string }) => (dispatch: Function) =>
  dispatch({
    type: OPEN_REMOVE_PROJECT_DIALOG,
    data: id
  });

export const closeRemoveProjectDialog = () => (dispatch: Function) =>
  dispatch({
    type: CLOSE_REMOVE_PROJECT_DIALOG
  });

export const closeWorkspaceDoneDialog = () => (dispatch: Function) =>
  dispatch({
    type: CLOSE_WORKSPACE_DONE_DIALOG
  });
export const closeVersionDoneDialog = () => (dispatch: Function) =>
  dispatch({
    type: CLOSE_VERSION_DONE_DIALOG
  });

export const saveGaSettings = ({
  id,
  idx,
  accountId,
  webPropertyId,
  internalWebPropertyId,
  webPropertyName,
  accountName,
  defaultProfileId,
  cb
}: {
  id: string,
  idx: string,
  accountId: string,
  webPropertyId: string,
  internalWebPropertyId: string,
  webPropertyName: string,
  accountName: string,
  defaultProfileId: string,
  cb: Function
}) => {
  return (dispatch: Function) => {
    let fetchUrl = PROJECT_GA_URL.replace(':id', `${id}`);

    dispatch({ type: GA_SAVING });
    fetch(fetchUrl, {
      method: 'POST',
      body: JSON.stringify({
        accountId,
        webPropertyId,
        internalWebPropertyId,
        webPropertyName,
        accountName,
        defaultProfileId
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch(
          fetchMe((userData) => {
            dispatch({
              type: GA_SAVED
            });
            if (cb) cb.call(this, data);
          })
        );
      });
  };
};

export const enableProject = ({ id, cb }: { id: string, cb: Function }) => {
  return (dispatch: Function) => {
    let fetchUrl = PROJECT_AVAILABLE_URL.replace(':id', `${id}`);
    fetch(fetchUrl, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch(
          fetchMe(() => {
            if (cb) cb.call(this, data);
          })
        );
      });
  };
};
export const disableProject = ({ id, cb }: { id: string, cb: Function }) => {
  return (dispatch: Function) => {
    let fetchUrl = PROJECT_AVAILABLE_URL.replace(':id', `${id}`);
    fetch(fetchUrl, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch(
          fetchMe(() => {
            dispatch({
              type: CLOSE_DISABLE_PROJECT_DIALOG
            });

            if (cb) cb.call(this, data);
          })
        );
      });
  };
};
export const deleteProject = ({ id, cb }: { id: string, cb: Function }) => {
  return (dispatch: Function) => {
    let fetchUrl = PROJECT_URL.replace(':id', `${id}`);
    fetch(fetchUrl, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch(
          fetchMe(() => {
            dispatch({
              type: CLOSE_REMOVE_PROJECT_DIALOG
            });

            if (cb) cb.call(this, data);
          })
        );
      });
  };
};
export const createProject = ({ cb }: { cb: Function }) => {
  return (dispatch: Function) => {
    let fetchUrl = PROJECTS_URL;

    fetch(fetchUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        const { _id } = data;

        dispatch(
          fetchMe(({ projects }) => {
            const idx = projects.indexOf(projects.find((p) => p._id === _id));
            dispatch(push(`/wizard/select-gtm-property?idx=${idx}`));

            if (cb) cb.call(this, data);
          })
        );
      });
  };
};

export const setSeoPerfomanceEmails = ({
  id,
  cb,
  seoPerfEmails,
  sendSeoPerformanceEmail
}: {
  id: string,
  cb: Function,
  seoPerfEmails: string,
  sendSeoPerformanceEmail: boolean
}) => (dispatch: Function) => {
  const fetchUrl = PROJECT_URL.replace(':id', `${id}`);
  fetch(`${fetchUrl}/seo-perfomance`, {
    body: JSON.stringify({
      seoPerfEmails,
      sendSeoPerformanceEmail
    }),
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  })
    .then((response) => response.json().then((data) => ({ data, status: response.status })))
    .then(({ data }) => {
      dispatch(
        fetchMe(({ projects }) => {
          const idx = projects.indexOf(projects.find((p) => p._id === id));
          dispatch(push(`/projects?idx=${idx}`));

          if (cb) cb.call(this, data);
        })
      );
    });
};

export default {
  setUpProject,
  saveGtmSettings,
  getAccounts,
  getSummary,
  getWebProperties,
  getDimensions,
  createProject,
  saveGaSettings,
  disableProject,
  enableProject,
  deleteProject,
  openRemoveProjectDialog,
  closeRemoveProjectDialog,
  openDisableProjectDialog,
  closeDisableProjectDialog,
  getTagSourceCode,
  closeVersionDoneDialog,
  closeWorkspaceDoneDialog,
  setSeoPerfomanceEmails
};



// WEBPACK FOOTER //
// ./src/actions/project.actions.js